import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { timezoneStringLabel } from '../../../../dateUtils';
function InterviewTimezone(_ref) {
  var timezoneStr = _ref.timezoneStr,
    _ref$dateStr = _ref.dateStr,
    dateStr = _ref$dateStr === void 0 ? '' : _ref$dateStr;
  var date = new Date(dateStr);
  if (isNaN(date.getTime())) {
    // Check if the date is invalid
    date = new Date(); // Assign the current date if invalid
  }
  return /*#__PURE__*/React.createElement(Fragment, null, timezoneStringLabel(timezoneStr, date));
}
InterviewTimezone.propTypes = {
  timezoneStr: PropTypes.string.isRequired,
  dateStr: PropTypes.string
};
InterviewTimezone.defaultProps = {
  dateStr: ''
};
export default InterviewTimezone;